

// import React, { useState, useEffect } from "react";
// import FormField from "../../../components/ui/FormField";
// import { Button } from "../../../components/Button";
// import { useSelector } from "react-redux";
// import { ArrowLeft } from "lucide-react";
// import { mgt2Api } from "../../../api/mgtApi2";

// // Helper functions to create initial state objects
// const createPersonalDetails = () => ({
//   holderName: "",
//   jointHolderNames: "",
//   address: "",
//   emailId: "",
//   panNo: "",
//   uniqueIdentificationNo: "",
//   fatherOrMotherOrSpouseName: "",
//   occupation: "",
//   nationality: "Indian",
// });

// const createSecurityDetails = () => ({
//   secured: true,
//   chargeRegistrationDate: "",
//   chargeIdentificationNumber: "",
//   assetParticulars: "",
// });

// const createMinorDetailsHolder = () => ({
//   guardianName: "",
//   minorDateOfBirth: "",
//   minorMembershipHolderDetails: {
//     dateOfBecomingHolder: "",
//     dateOfReceiptOfNomination: "",
//     abeyanceSecuritiesCount: "",
//     lienRecord: "",
//     dateOfCessation: "",
//   },
// });

// const createDebentureAllotmentTransferDetail = () => ({
//   allotmentOrTransferNo: "",
//   dateOfAllotmentOrTransfer: "",
//   numberOfDebenturesOrSecuritiesAllottedOrTransferred: "",

//   distinctiveNumberRanges: [],

//   folioOfTransferor: "",
//   nameOfTransferor: "",
//   dateOfIssueOrEndorsementOfCertificate: "",
//   certificateNumber: "",
//   amount: {
//     amountPayable: "",
//     amountPaid: "",
//     amountDue: "",
//   },
//   considerationOtherThanCashDetails: "",
//   dateOfTransferTransmissionRedemptionForfeiture: "",
//   numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed: "",

//   transferDistinctiveNumberRanges: [],

//   folioOfTransferee: "",
//   nameOfTransferee: "",
//   balanceUnitsLeft: "",
//   otherRemarks: "",
//   authentication: "",
// });

// const MgtTwoForm = () => {
//   const token = useSelector((state) => state.auth.access_token);
//   const companies = useSelector((state) => state.account.accountDetails);

//   const [formData, setFormData] = useState({
//     accountId: "",
//     companyName: "",
//     classOfDebentures: "",
//    subClassOfDebentures:"",
//     nominalValuePerUnit: "",
//     totalNumberOfDebentures: "",
//     totalSharesHeld: "",
//     folioNumber: "",
//     personalDetails: createPersonalDetails(),
//     securityDetails: createSecurityDetails(),
//     minorDetailsHolder: createMinorDetailsHolder(),
//     debentureAllotmentTransferDetails: [
//       createDebentureAllotmentTransferDetail(),
//     ],
//   });

//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState("");

//   console.log("🔍 RENDER - Current accountId:", formData.accountId);
//   console.log("🔍 RENDER - Current companyName:", formData.companyName);

//   // Handle company selection
//   const handleCompanyChange = (e) => {
//     const selectedValue = e.target.value;

//     console.log("🏢 Selected value:", selectedValue);
//     console.log("🏢 Available companies:", companies);

//     if (selectedValue === "") {
//       setFormData((prev) => ({
//         ...prev,
//         accountId: "",
//         companyName: "",
//       }));
//       return;
//     }

//     const selectedCompany = companies.find(
//       (company) => String(company.id) === String(selectedValue),
//     );

//     console.log("✅ Found company:", selectedCompany);

//     if (selectedCompany) {
//       setFormData((prev) => ({
//         ...prev,
//         accountId: selectedCompany.id,
//         companyName: selectedCompany.accountName || "",
//       }));
//       console.log("✅ Updated accountId to:", selectedCompany.id);
//       console.log("✅ Updated companyName to:", selectedCompany.accountName);
//     } else {
//       console.error("❌ Company not found for value:", selectedValue);
//     }
//   };

//   // Handle root level changes
//   const handleRootChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   // Handle personal details changes
//   const handlePersonalChange = (section, field, value) => {
//     setFormData((prev) => {
//       // Personal Details
//       if (section === "personalDetails") {
//         return {
//           ...prev,
//           personalDetails: {
//             ...prev.personalDetails,
//             [field]: value,
//           },
//         };
//       }

//       // Security Details
//       if (section === "securityDetails") {
//         return {
//           ...prev,
//           securityDetails: {
//             ...prev.securityDetails,
//             [field]: value,
//           },
//         };
//       }

//       // Minor Details (top-level)
//       if (section === "minorDetailsHolder") {
//         return {
//           ...prev,
//           minorDetailsHolder: {
//             ...prev.minorDetailsHolder,
//             [field]: value,
//           },
//         };
//       }

//       // Minor Membership Holder Details (nested)
//       if (section === "minorMembershipHolderDetails") {
//         return {
//           ...prev,
//           minorDetailsHolder: {
//             ...prev.minorDetailsHolder,
//             minorMembershipHolderDetails: {
//               ...prev.minorDetailsHolder.minorMembershipHolderDetails,
//               [field]: value,
//             },
//           },
//         };
//       }

//       return prev;
//     });
//   };

//   // Handle debenture allotment changes (WITH VALIDATION)
//   const handleDebentureChange = (
//     index,
//     field,
//     value,
//     subField = null,
//     rangeIndex = null,
//   ) => {
//     setFormData((prev) => {
//       const updated = [...prev.debentureAllotmentTransferDetails];

//       // 🔹 CASE 1: Distinctive / Transfer RANGE arrays WITH VALIDATION
//       if (
//         (field === "distinctiveNumberRanges" ||
//           field === "transferDistinctiveNumberRanges") &&
//         rangeIndex !== null &&
//         subField
//       ) {
//         const numValue = value === "" ? "" : Number(value);
//         const currentRanges = updated[index][field] || [];

//         // 🔥 VALIDATION: Block 'from' if it's LESS than or EQUAL to previous range's 'to'
//         if (subField === "from" && numValue !== "" && rangeIndex > 0) {
//           const previousRange = currentRanges[rangeIndex - 1];
//           const previousTo = Number(previousRange?.to) || 0;

//           if (previousTo > 0 && numValue <= previousTo) {
//             alert(`❌ Cannot enter ${numValue}.\n\n'From' value must be greater than the previous range's 'To' value (${previousTo}).\n\nSuggested value: ${previousTo + 1}`);
//             return prev;
//           }
//         }

//         updated[index] = {
//           ...updated[index],
//           [field]: updated[index][field].map((range, i) =>
//             i === rangeIndex
//               ? {
//                   ...range,
//                   [subField]: numValue,
//                 }
//               : range,
//           ),
//         };
//       }

//       // 🔹 CASE 2: OLD From-To objects (kept as-is)
//       else if (subField) {
//         if (
//           field === "distinctiveNumberFromTo" ||
//           field === "transferDistinctiveNoFromTo"
//         ) {
//           updated[index] = {
//             ...updated[index],
//             [field]: {
//               ...updated[index][field],
//               [subField]: value,
//             },
//           };
//         }

//         // 🔹 CASE 3: Amount object
//         else if (field === "amount") {
//           updated[index] = {
//             ...updated[index],
//             amount: {
//               ...updated[index].amount,
//               [subField]: value,
//             },
//           };
//         }
//       }

//       // 🔹 CASE 4: Normal fields
//       else {
//         updated[index] = {
//           ...updated[index],
//           [field]: value,
//         };
//       }

//       return {
//         ...prev,
//         debentureAllotmentTransferDetails: updated,
//       };
//     });
//   };

//   // Add new debenture allotment
//   const addDebentureAllotment = () => {
//     setFormData((prev) => ({
//       ...prev,
//       debentureAllotmentTransferDetails: [
//         ...prev.debentureAllotmentTransferDetails,
//         createDebentureAllotmentTransferDetail(),
//       ],
//     }));
//   };

//   // Remove debenture allotment
//   const removeDebentureAllotment = (index) => {
//     if (formData.debentureAllotmentTransferDetails.length > 1) {
//       setFormData((prev) => ({
//         ...prev,
//         debentureAllotmentTransferDetails:
//           prev.debentureAllotmentTransferDetails.filter((_, i) => i !== index),
//       }));
//     }
//   };

//   const addRange = (holdingIndex, field) => {
//     setFormData((prev) => {
//       const updated = [...prev.debentureAllotmentTransferDetails];

//       if (!Array.isArray(updated[holdingIndex][field])) {
//         updated[holdingIndex][field] = [];
//       }

//       // 🔥 AUTO-SUGGEST: Calculate suggested 'from' value based on last range
//       const currentRanges = updated[holdingIndex][field];
//       let suggestedFrom = "";

//       if (currentRanges.length > 0) {
//         const lastRange = currentRanges[currentRanges.length - 1];
//         if (lastRange.to) {
//           suggestedFrom = Number(lastRange.to) + 1;
//         }
//       }

//       updated[holdingIndex][field] = [
//         ...updated[holdingIndex][field],
//         { from: suggestedFrom, to: "" },
//       ];

//       return { ...prev, debentureAllotmentTransferDetails: updated };
//     });
//   };

//   const removeRange = (holdingIndex, field, rangeIndex) => {
//     setFormData((prev) => {
//       const updated = [...prev.debentureAllotmentTransferDetails];

//       updated[holdingIndex][field] = updated[holdingIndex][field]
//         .filter(Boolean)
//         .filter((_, i) => i !== rangeIndex);

//       return { ...prev, debentureAllotmentTransferDetails: updated };
//     });
//   };

//   const cleanRanges = (ranges = []) =>
//     Array.isArray(ranges)
//       ? ranges
//           .filter((r) => r?.from && r?.to)
//           .map((r) => ({
//             from: Number(r.from),
//             to: Number(r.to),
//           }))
//       : [];

//   // Handle form submission
//   const handleSave = async (e) => {
//     if (e) {
//       e.preventDefault();
//       e.stopPropagation();
//     }

//     console.log("🚀 ========== FORM SUBMISSION STARTED ==========");
//     console.log("📋 Current formData:", JSON.stringify(formData, null, 2));

//     // Validation
//     if (!formData.accountId) {
//       const errorMsg = "Please select a company.";
//       setError(errorMsg);
//       console.error("❌ Validation failed: No company selected");
//       alert(errorMsg);
//       return;
//     }

//     if (!formData.classOfDebentures) {
//       const errorMsg = "Please enter class of debentures.";
//       setError(errorMsg);
//       console.error("❌ Validation failed: No class of debentures");
//       alert(errorMsg);
//       return;
//     }

//     setSubmitting(true);
//     setError("");

//     try {
//       // Prepare the data according to the Postman payload structure
//       const apiData = {
//         classOfDebentures: formData.classOfDebentures,
//          subClassOfDebentures:formData.subClassOfDebentures,
//         nominalValuePerUnit: Number(formData.nominalValuePerUnit) || 0,
//         totalNumberOfDebentures: Number(formData.totalNumberOfDebentures) || 0,
//         totalSharesHeld: Number(formData.totalSharesHeld) || 0,
//         folioNumber: formData.folioNumber,

//         personalDetails: {
//           holderName: formData.personalDetails.holderName,
//           jointHolderNames: formData.personalDetails.jointHolderNames || null,
//           address: formData.personalDetails.address,
//           emailId: formData.personalDetails.emailId,
//           panNo: formData.personalDetails.panNo,
//           uniqueIdentificationNo:
//             formData.personalDetails.uniqueIdentificationNo || null,
//           fatherOrMotherOrSpouseName:
//             formData.personalDetails.fatherOrMotherOrSpouseName || null,
//           occupation: formData.personalDetails.occupation || null,
//           nationality: formData.personalDetails.nationality || "Indian",
//         },

//         securityDetails: {
//           secured: formData.securityDetails.secured || null,
//           chargeRegistrationDate:
//             formData.securityDetails.chargeRegistrationDate,
//           chargeIdentificationNumber:
//             formData.securityDetails.chargeIdentificationNumber,
//           assetParticulars: formData.securityDetails.assetParticulars,
//         },

//         minorDetailsHolder: {
//           guardianName: formData.minorDetailsHolder.guardianName || null,
//           minorDateOfBirth:
//             formData.minorDetailsHolder.minorDateOfBirth || null,
//           minorMembershipHolderDetails: {
//             dateOfBecomingHolder:
//               formData.minorDetailsHolder.minorMembershipHolderDetails
//                 .dateOfBecomingHolder || null,
//             dateOfReceiptOfNomination:
//               formData.minorDetailsHolder.minorMembershipHolderDetails
//                 .dateOfReceiptOfNomination || null,
//             abeyanceSecuritiesCount:
//               Number(
//                 formData.minorDetailsHolder.minorMembershipHolderDetails
//                   .abeyanceSecuritiesCount,
//               ) || 0,
//             lienRecord:
//               formData.minorDetailsHolder.minorMembershipHolderDetails
//                 .lienRecord || null,
//             dateOfCessation:
//               formData.minorDetailsHolder.minorMembershipHolderDetails
//                 .dateOfCessation || null,
//           },
//         },

//         debentureAllotmentTransferDetails:
//           formData.debentureAllotmentTransferDetails.map((item, index) => ({
//             allotmentOrTransferNo:
//               item.allotmentOrTransferNo ||
//               `ALT-${String(index + 1).padStart(3, "0")}`,
//             dateOfAllotmentOrTransfer: item.dateOfAllotmentOrTransfer || null,
//             numberOfDebenturesOrSecuritiesAllottedOrTransferred:
//               Number(
//                 item.numberOfDebenturesOrSecuritiesAllottedOrTransferred,
//               ) || 0,
//             // ✅ FIXED: MULTIPLE DISTINCTIVE RANGES
//             distinctiveNumberRanges: cleanRanges(item.distinctiveNumberRanges),

//             folioOfTransferor: item.folioOfTransferor || null,
//             nameOfTransferor: item.nameOfTransferor || null,
//             dateOfIssueOrEndorsementOfCertificate:
//               item.dateOfIssueOrEndorsementOfCertificate || null,
//             certificateNumber: item.certificateNumber || null,
//             amount: {
//               amountPayable: Number(item.amount.amountPayable) || 0,
//               amountPaid: Number(item.amount.amountPaid) || 0,
//               amountDue: Number(item.amount.amountDue) || 0,
//             },
//             considerationOtherThanCashDetails:
//               item.considerationOtherThanCashDetails || null,
//             dateOfTransferTransmissionRedemptionForfeiture:
//               item.dateOfTransferTransmissionRedemptionForfeiture || null,
//             numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed:
//               Number(
//                 item.numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed,
//               ) || 0,

//             // ✅ FIXED: MULTIPLE TRANSFER RANGES
//             transferDistinctiveNumberRanges: cleanRanges(
//               item.transferDistinctiveNumberRanges,
//             ),
//             folioOfTransferee: item.folioOfTransferee || null,
//             nameOfTransferee: item.nameOfTransferee || null,
//             balanceUnitsLeft: Number(item.balanceUnitsLeft) || 0,
//             otherRemarks: item.otherRemarks || null,
//             authentication: item.authentication || null,
//           })),
//       };

//       console.log(
//         "📤 Submitting MGT-2 data:",
//         JSON.stringify(apiData, null, 2),
//       );

//       const response = await mgt2Api.submitMgt2Form(
//         apiData,
//         formData.accountId,
//         token,
//       );

//       if (
//         response &&
//         (response.id || response._id || response.success || response.data)
//       ) {
//         alert("MGT-2 form submitted successfully!");
//         console.log("🎉 Form submitted successfully!");

//         // Reset form
//         setFormData({
//           accountId: "",
//           companyName: "",
//           classOfDebentures: "",
//           nominalValuePerUnit: "",
//           totalNumberOfDebentures: "",
//           totalSharesHeld: "",
//           folioNumber: "",
//           personalDetails: createPersonalDetails(),
//           securityDetails: createSecurityDetails(),
//           minorDetailsHolder: createMinorDetailsHolder(),
//           debentureAllotmentTransferDetails: [
//             createDebentureAllotmentTransferDetail(),
//           ],
//         });
//       } else {
//         const errorMsg = "Failed to submit form. Please try again.";
//         setError(errorMsg);
//         console.error("❌ Unexpected response format:", response);
//         alert(errorMsg);
//       }
//     } catch (err) {
//       console.error("❌ ========== SUBMISSION ERROR ==========");
//       console.error("❌ Error object:", err);
//       console.error("❌ Error message:", err.message);
//       console.error("❌ Error response:", err.response);
//       console.error("❌ Error response data:", err.response?.data);

//       const errorMsg = `Submission failed: ${err.response?.data?.message || err.message || "Please try again"}`;
//       setError(errorMsg);
//       alert(errorMsg);
//     } finally {
//       setSubmitting(false);
//       console.log("🏁 Submission process completed");
//     }
//   };

//   return (
//     <div className="relative min-h-screen bg-gray-100 p-6">
//       <button
//         onClick={() => window.history.back()}
//         className="absolute top-6 left-6 flex items-center gap-2 text-gray-600 hover:text-gray-900"
//       >
//         <ArrowLeft size={22} />
//         <span className="text-sm font-medium">Back</span>
//       </button>
//       <div className="max-w-6xl mx-auto p-6 bg-white rounded-lg shadow-md">
//         <div className=" mb-2 flex flex-col items-center justify-center gap-1 ">
//           <h1 className="text-2xl font-bold text-gray-800">Form No. MGT - 2</h1>
//           <h2 className="text-lg text-gray-600 ">
//             Register of debenture holders/ other securities holders
//           </h2>
//           <p className="text-sm text-gray-500 mt-2 ">
//             [Pursuant to section 88 of the Companies Act, 2013 and rule 3(2) of
//             the Companies (Management and Administration) Rules, 2014]
//           </p>
//         </div>

//         {/* Error Display */}
//         {error && (
//           <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md">
//             <p className="text-red-600 text-sm">{error}</p>
//           </div>
//         )}

//         {/* Company Selection */}
//         <div className="mb-6">
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             Name of the company *
//           </label>
//           <select
//             value={formData.accountId}
//             onChange={handleCompanyChange}
//             disabled={loading}
//             className="w-50 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//           >
//             <option value="">Select a company</option>
//             {companies.map((company) => (
//               <option key={company.id} value={company.id}>
//                 {company.accountName || `Company ${company.id}`}
//               </option>
//             ))}
//           </select>
//         </div>

//         <p className="text-sm text-gray-600 ">
//           (TO BE MAINTAINED SEPARATELY FOR EACH CLASS OF DEBENTURES / OTHER
//           SECURITIES IN RESPECT OF EACH HOLDER)
//         </p>

//         {/* Basic Debenture Information */}
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-3">
//           <FormField
//             label="Class of debentureb share"
//             type="dropdown"
//             value={formData.classOfDebentures}
//             onChange={(value) => handleRootChange("classOfDebentures", value)}
//             options={["EQUITY SHARES", "PREFERENCE SHARES"]}
//             required
//           />
//             <FormField
//                       label="sub class of debentures holder"
//                       value={formData.subClassOfDebentures}
//                       onChange={(value) => handleRootChange("subClassOfDebentures", value)}
//                       required
//                     />
//           <FormField
//             label="Nominal value per unit (₹)"
//             value={formData.nominalValuePerUnit}
//             onChange={(value) => handleRootChange("nominalValuePerUnit", value)}
//             type="number"
//             required
//           />
//           <FormField
//             label="Total number of debentures"
//             value={formData.totalNumberOfDebentures}
//             onChange={(value) =>
//               handleRootChange("totalNumberOfDebentures", value)
//             }
//             type="number"
//             required
//           />
//           <FormField
//             label="Total shares held"
//             value={formData.totalSharesHeld}
//             onChange={(value) => handleRootChange("totalSharesHeld", value)}
//             type="number"
//             required
//           />
//         </div>
//         <hr className="my-6 border-gray-800" />

//         {/* Personal Details Section */}
//         <div className="">
//           <h3 className="text-lg font-semibold text-gray-800 mb-1">
//             Personal Details
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
//             <FormField
//               label="Holder name"
//               value={formData.personalDetails.holderName}
//               onChange={(value) =>
//                 handlePersonalChange("personalDetails", "holderName", value)
//               }
//               required
//             />
//             <FormField
//               label="Joint holder names (if any)"
//               value={formData.personalDetails.jointHolderNames}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "personalDetails",
//                   "jointHolderNames",
//                   value,
//                 )
//               }
//             />
//             <FormField
//               label="Email ID"
//               value={formData.personalDetails.emailId}
//               onChange={(value) =>
//                 handlePersonalChange("personalDetails", "emailId", value)
//               }
//               type="email"
//               required
//             />
//             <FormField
//               label="PAN number"
//               value={formData.personalDetails.panNo}
//               onChange={(value) =>
//                 handlePersonalChange("personalDetails", "panNo", value)
//               }
//               required
//             />
//             <FormField
//               label="Unique identification number"
//               value={formData.personalDetails.uniqueIdentificationNo}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "personalDetails",
//                   "uniqueIdentificationNo",
//                   value,
//                 )
//               }
//             />
//             <FormField
//               label="Father/Mother/Spouse name"
//               value={formData.personalDetails.fatherOrMotherOrSpouseName}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "personalDetails",
//                   "fatherOrMotherOrSpouseName",
//                   value,
//                 )
//               }
//             />

//             <FormField
//               label="Occupation"
//               value={formData.personalDetails.occupation}
//               onChange={(value) =>
//                 handlePersonalChange("personalDetails", "occupation", value)
//               }
//             />
//             <FormField
//               label="Nationality"
//               value={formData.personalDetails.nationality}
//               onChange={(value) =>
//                 handlePersonalChange("personalDetails", "nationality", value)
//               }
//             />
//                 <FormField
//               label="Address"
//               value={formData.personalDetails.address}
//               onChange={(value) =>
//                 handlePersonalChange("personalDetails", "address", value)
//               }
//               type="description"
//               rows={2}

//             />
//           </div>
//         </div>

//         <hr className="my-6 border-gray-800" />

//         {/* Minor Details Section */}
//         <div className="mb-4">
//           <h3 className="text-lg font-semibold text-gray-800 mb-1">
//             Minor Details (if applicable)
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//             <FormField
//               label="Guardian name"
//               value={formData.minorDetailsHolder.guardianName}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "minorDetailsHolder",
//                   "guardianName",
//                   value,
//                 )
//               }
//             />
//             <FormField
//               label="Minor date of birth"
//               value={formData.minorDetailsHolder.minorDateOfBirth}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "minorDetailsHolder",
//                   "minorDateOfBirth",
//                   value,
//                 )
//               }
//               type="date"
//             />
//           </div>
//           <div className="mt-3">
//             <h3 className="text-lg font-semibold text-gray-800 mb-2">
//               Minor Membership Holder Details
//             </h3>

//             <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
//               <FormField
//                 label="Date of becoming holder"
//                 value={
//                   formData.minorDetailsHolder.minorMembershipHolderDetails
//                     .dateOfBecomingHolder
//                 }
//                 onChange={(value) =>
//                   handlePersonalChange(
//                     "minorMembershipHolderDetails",
//                     "dateOfBecomingHolder",
//                     value,
//                   )
//                 }
//                 type="date"
//               />
//               <FormField
//                 label="Date of receipt of nomination"
//                 value={
//                   formData.minorDetailsHolder.minorMembershipHolderDetails
//                     .dateOfReceiptOfNomination
//                 }
//                 onChange={(value) =>
//                   handlePersonalChange(
//                     "minorMembershipHolderDetails",
//                     "dateOfReceiptOfNomination",
//                     value,
//                   )
//                 }
//                 type="date"
//               />
//               <FormField
//                 label="Abeyance securities count"
//                 value={
//                   formData.minorDetailsHolder.minorMembershipHolderDetails
//                     .abeyanceSecuritiesCount
//                 }
//                 onChange={(value) =>
//                   handlePersonalChange(
//                     "minorMembershipHolderDetails",
//                     "abeyanceSecuritiesCount",
//                     value,
//                   )
//                 }
//                 type="number"
//               />
//               <FormField
//                 label="Lien record"
//                 value={
//                   formData.minorDetailsHolder.minorMembershipHolderDetails
//                     .lienRecord
//                 }
//                 onChange={(value) =>
//                   handlePersonalChange(
//                     "minorMembershipHolderDetails",
//                     "lienRecord",
//                     value,
//                   )
//                 }
//               />
//               <FormField
//                 label="Date of cessation"
//                 value={
//                   formData.minorDetailsHolder.minorMembershipHolderDetails
//                     .dateOfCessation
//                 }
//                 onChange={(value) =>
//                   handlePersonalChange(
//                     "minorMembershipHolderDetails",
//                     "dateOfCessation",
//                     value,
//                   )
//                 }
//                 type="date"
//               />
//             </div>
//           </div>
//         </div>

//         <hr className="my-6 border-gray-800" />

//         {/* Security Details Section */}
//         <div className="mb-2">
//           <h3 className="text-lg font-semibold text-gray-800 mb-2">
//             Security Details
//           </h3>
//           <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//             <FormField
//               label="Whether repayment of the debentures / other securities is secured: Yes/No"
//               type="dropdown"
//               options={[
//                 { label: "Yes", value: true },
//                 { label: "No", value: false },
//               ]}
//               value={formData.securityDetails.secured}
//               onChange={(value) =>
//                 handlePersonalChange("securityDetails", "secured", value)
//               }
//             />

//             <FormField
//               label="Lock-in periodIf secured, date of registration of charge with the ROC"
//               type="date"
//               value={formData.securityDetails.chargeRegistrationDate}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "securityDetails",
//                   "chargeRegistrationDate",
//                   value,
//                 )
//               }
//             />
//             <FormField
//               label="Charge Identification Number allotted for the charge"
//               value={formData.securityDetails.chargeIdentificationNumber}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "securityDetails",
//                   "chargeIdentificationNumber",
//                   value,
//                 )
//               }
//             />

//             <FormField
//               label="Brief particulars of the assets to secure such debentures / other securities"
//               value={formData.securityDetails.assetParticulars}
//               onChange={(value) =>
//                 handlePersonalChange(
//                   "securityDetails",
//                   "assetParticulars",
//                   value,
//                 )
//               }
//             />
//           </div>
//         </div>

//         <hr className="my-6 border-gray-800" />

//         {/* Debenture Allotment/Transfer Details */}
//         {formData.debentureAllotmentTransferDetails.map((detail, index) => (
//           <div
//             key={index}
//             className="mb-2 p-2 bg-gray-100 border border-gray-400 rounded-lg"
//           >
//             <div className="flex justify-between items-center mb-2">
//               <h3 className="text-lg font-semibold text-gray-800">
//                 Debenture Allotment/Transfer Details #{index + 1}
//               </h3>
//               {formData.debentureAllotmentTransferDetails.length > 1 && (
//                 <button
//                   type="button"
//                   onClick={() => removeDebentureAllotment(index)}
//                   className="text-red-600 hover:bg-red-50 px-3 py-1 rounded border border-red-200 text-xs font-bold"
//                 >
//                   DELETE ALLOTMENT
//                 </button>
//               )}
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
//               <FormField
//                 label="Allotment or transfer number"
//                 value={detail.allotmentOrTransferNo}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "allotmentOrTransferNo", value)
//                 }
//               />
//               <FormField
//                 label="Date of allotment or transfer"
//                 value={detail.dateOfAllotmentOrTransfer}
//                 onChange={(value) =>
//                   handleDebentureChange(
//                     index,
//                     "dateOfAllotmentOrTransfer",
//                     value,
//                   )
//                 }
//                 type="date"
//                   max={new Date().toISOString().split("T")[0]}  
//               />
//               <FormField
//                 label="Number of debentures/securities allotted or transferred"
//                 value={
//                   detail.numberOfDebenturesOrSecuritiesAllottedOrTransferred
//                 }
//                 onChange={(value) =>
//                   handleDebentureChange(
//                     index,
//                     "numberOfDebenturesOrSecuritiesAllottedOrTransferred",
//                     value,
//                   )
//                 }
//                 type="number"
//               />
//               <div className="col-span-4 ">
//                 <h4 className="text-sm font-semibold text-gray-700 mb-1">
//                   Distinctive Number Ranges
//                 </h4>

//                 {detail.distinctiveNumberRanges.map((range, rangeIndex) => (
//                   <div
//                     key={rangeIndex}
//                     className="grid grid-cols-4 gap-2 items-end mb-2 p-2 bg-white rounded border border-gray-200"
//                   >
//                     <FormField
//                       label={rangeIndex > 0 && detail.distinctiveNumberRanges[rangeIndex - 1]?.to 
//                         ? `From (min: ${Number(detail.distinctiveNumberRanges[rangeIndex - 1].to) + 1})` 
//                         : "From"}
//                       type="number"
//                       value={range.from}
//                       onChange={(value) =>
//                         handleDebentureChange(
//                           index,
//                           "distinctiveNumberRanges",
//                           value,
//                           "from",
//                           rangeIndex,
//                         )
//                       }
//                     />

//                     <FormField
//                       label="To"
//                       type="number"
//                       value={range.to}
//                       onChange={(value) =>
//                         handleDebentureChange(
//                           index,
//                           "distinctiveNumberRanges",
//                           value,
//                           "to",
//                           rangeIndex,
//                         )
//                       }
//                     />

//                     {detail.distinctiveNumberRanges.length > 1 && (
//                       <button
//                         type="button"
//                         onClick={() =>
//                           removeRange(
//                             index,
//                             "distinctiveNumberRanges",
//                             rangeIndex,
//                           )
//                         }
//                         className="text-red-600 hover:text-red-800 text-xs col-span-2 text-left font-semibold"
//                       >
//                         ❌ Remove range
//                       </button>
//                     )}
//                   </div>
//                 ))}

//                 <button
//                   type="button"
//                   onClick={() => addRange(index, "distinctiveNumberRanges")}
//                   className="text-primary text-sm font-semibold hover:underline"
//                 >
//                   ➕ Add Distinctive Range
//                 </button>
//               </div>

//               <FormField
//                 label="Folio of transferor"
//                 value={detail.folioOfTransferor}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "folioOfTransferor", value)
//                 }
//               />
//               <FormField
//                 label="Name of transferor"
//                 value={detail.nameOfTransferor}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "nameOfTransferor", value)
//                 }
//               />
//               <FormField
//                 label="Date of issue or endorsement of certificate"
//                 value={detail.dateOfIssueOrEndorsementOfCertificate}
//                 onChange={(value) =>
//                   handleDebentureChange(
//                     index,
//                     "dateOfIssueOrEndorsementOfCertificate",
//                     value,
//                   )
//                 }
//                 type="date"
//                   max={new Date().toISOString().split("T")[0]}  
//               />
//               <FormField
//                 label="Certificate number"
//                 value={detail.certificateNumber}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "certificateNumber", value)
//                 }
//               />
//               <FormField
//                 label="Amount payable (₹)"
//                 value={detail.amount.amountPayable}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "amount", value, "amountPayable")
//                 }
//                 type="number"
//               />
//               <FormField
//                 label="Amount paid (₹)"
//                 value={detail.amount.amountPaid}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "amount", value, "amountPaid")
//                 }
//                 type="number"
//               />
//               <FormField
//                 label="Amount due (₹)"
//                 value={detail.amount.amountDue}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "amount", value, "amountDue")
//                 }
//                 type="number"
//               />
//               <FormField
//                 label="Consideration other than cash details"
//                 value={detail.considerationOtherThanCashDetails}
//                 onChange={(value) =>
//                   handleDebentureChange(
//                     index,
//                     "considerationOtherThanCashDetails",
//                     value,
//                   )
//                 }
//               />
//               <FormField
//                 label="Date of transfer"
//                 value={detail.dateOfTransferTransmissionRedemptionForfeiture}
//                 onChange={(value) =>
//                   handleDebentureChange(
//                     index,
//                     "dateOfTransferTransmissionRedemptionForfeiture",
//                     value,
//                   )
//                 }
//                 type="date"
//               />
//               <FormField
//                 label="Number of units transferred"
//                 value={
//                   detail.numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed
//                 }
//                 onChange={(value) =>
//                   handleDebentureChange(
//                     index,
//                     "numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed",
//                     value,
//                   )
//                 }
//                 type="number"
//               />
//            <div className="col-span-4 ">
//                 <h4 className="text-sm font-semibold text-gray-700 mb-1">
//                    Transfer Distinctive Number Ranges
//                 </h4>

//                 {detail.transferDistinctiveNumberRanges.map((range, rangeIndex) => (
//                   <div
//                     key={rangeIndex}
//                     className="grid grid-cols-4 gap-2 items-end mb-2 p-2 bg-white rounded border border-gray-200"
//                   >
//                     <FormField
//                       label={rangeIndex > 0 && detail.transferDistinctiveNumberRanges[rangeIndex - 1]?.to 
//                         ? `From (min: ${Number(detail.transferDistinctiveNumberRanges[rangeIndex - 1].to) + 1})` 
//                         : "From"}
//                       type="number"
//                       value={range.from}
//                       onChange={(value) =>
//                         handleDebentureChange(
//                           index,
//                           "transferDistinctiveNumberRanges",
//                           value,
//                           "from",
//                           rangeIndex,
//                         )
//                       }
//                     />

//                     <FormField
//                       label="To"
//                       type="number"
//                       value={range.to}
//                       onChange={(value) =>
//                         handleDebentureChange(
//                           index,
//                           "transferDistinctiveNumberRanges",
//                           value,
//                           "to",
//                           rangeIndex,
//                         )
//                       }
//                     />

//                     {detail.transferDistinctiveNumberRanges.length > 1 && (
//                       <button
//                         type="button"
//                         onClick={() =>
//                           removeRange(
//                             index,
//                             "transferDistinctiveNumberRanges",
//                             rangeIndex,
//                           )
//                         }
//                         className="text-red-600 hover:text-red-800 text-xs col-span-2 text-left font-semibold"
//                       >
//                         ❌ Remove range
//                       </button>
//                     )}
//                   </div>
//                 ))}

//                 <button
//                   type="button"
//                   onClick={() => addRange(index, "transferDistinctiveNumberRanges")}
//                   className="text-primary text-sm font-semibold hover:underline"
//                 >
//                   ➕ Add Transfer Range
//                 </button>
//               </div>
//               <FormField
//                 label="Folio of transferee"
//                 value={detail.folioOfTransferee}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "folioOfTransferee", value)
//                 }
//               />
//               <FormField
//                 label="Name of transferee"
//                 value={detail.nameOfTransferee}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "nameOfTransferee", value)
//                 }
//               />
//               <FormField
//                 label="Balance units left"
//                 value={detail.balanceUnitsLeft}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "balanceUnitsLeft", value)
//                 }
//                 type="number"
//               />

//               <FormField
//                 label="Authentication"
//                 value={detail.authentication}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "authentication", value)
//                 }
//               />

//                 <FormField
//                 label="Other remarks"
//                 value={detail.otherRemarks}
//                 onChange={(value) =>
//                   handleDebentureChange(index, "otherRemarks", value)
//                 }
//                 type="description"
//                 rows={2}
//               />
//             </div>
//           </div>
//         ))}

//         {/* Action Buttons */}
//         <div className="flex gap-4 justify-between">
//           <button
//             type="button"
//             onClick={addDebentureAllotment}
//             className="bg-primary text-white px-6 py-2 rounded-md transition-colors"
//           >
//             Add Debenture Allotment
//           </button>

//           <button
//             type="button"
//             onClick={handleSave}
//             disabled={submitting || !formData.accountId}
//             className="bg-primary text-white px-6 py-2 rounded-md disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
//           >
//             {submitting ? "Submitting..." : "Submit MGT-2 Form"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MgtTwoForm;

import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";
import { useSelector } from "react-redux";
import { ArrowLeft, Plus, Trash2 } from "lucide-react";
import { mgt2Api } from "../../../api/mgtApi2";

// Helper functions to create initial state objects
const createPersonalDetails = () => ({
  holderName: "",
  jointHolderNames: "",
  address: "",
  emailId: "",
  panNo: "",
  uniqueIdentificationNo: "",
  fatherOrMotherOrSpouseName: "",
  occupation: "",
  nationality: "Indian",
});

const createSecurityDetails = () => ({
  secured: true,
  chargeRegistrationDate: "",
  chargeIdentificationNumber: "",
  assetParticulars: "",
});

const createMinorDetailsHolder = () => ({
  guardianName: "",
  minorDateOfBirth: "",
  minorMembershipHolderDetails: {
    dateOfBecomingHolder: "",
    dateOfReceiptOfNomination: "",
    abeyanceSecuritiesCount: "",
    lienRecord: "",
    dateOfCessation: "",
  },
});

const createDebentureAllotmentTransferDetail = () => ({
  allotmentOrTransferNo: "",
  dateOfAllotmentOrTransfer: "",
  numberOfDebenturesOrSecuritiesAllottedOrTransferred: "",
  allotmentDistinctiveNumber: {
    from: "",
    to: "",
  },
  folioOfTransferor: "",
  nameOfTransferor: "",
  dateOfIssueOrEndorsementOfCertificate: "",
  certificateNumber: "",
  amount: {
    amountPayable: "",
    amountPaid: "",
    amountDue: "",
  },
  considerationOtherThanCashDetails: "",
  dateOfTransferTransmissionRedemptionForfeiture: "",
  numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed: "",
  transfereeDistinctiveNumber: {
    from: "",
    to: "",
  },
  folioOfTransferee: "",
  nameOfTransferee: "",
  balanceUnitsLeft: "",
  otherRemarks: "",
  authentication: "",
});

const MgtTwoForm = () => {
  const token = useSelector((state) => state.auth.access_token);
  const companies = useSelector((state) => state.account.accountDetails);

  const [formData, setFormData] = useState({
    accountId: "",
    companyName: "",
    classOfDebentures: "",
    nominalValuePerUnit: "",
    totalNumberOfDebentures: "",
    totalSharesHeld: "",
    folioNumber: "",
    personalDetails: createPersonalDetails(),
    securityDetails: createSecurityDetails(),
    minorDetailsHolder: createMinorDetailsHolder(),
    debentureAllotmentTransferDetails: [
      createDebentureAllotmentTransferDetail(),
    ],
  });

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  console.log("🔍 RENDER - Current accountId:", formData.accountId);
  console.log("🔍 RENDER - Current companyName:", formData.companyName);

  // Handle company selection
  const handleCompanyChange = (e) => {
    const selectedValue = e.target.value;

    console.log("🏢 Selected value:", selectedValue);
    console.log("🏢 Available companies:", companies);

    if (selectedValue === "") {
      setFormData((prev) => ({
        ...prev,
        accountId: "",
        companyName: "",
      }));
      return;
    }

    const selectedCompany = companies.find(
      (company) => String(company.id) === String(selectedValue),
    );

    console.log("✅ Found company:", selectedCompany);

    if (selectedCompany) {
      setFormData((prev) => ({
        ...prev,
        accountId: selectedCompany.id,
        companyName: selectedCompany.accountName || "",
      }));
      console.log("✅ Updated accountId to:", selectedCompany.id);
      console.log("✅ Updated companyName to:", selectedCompany.accountName);
    } else {
      console.error("❌ Company not found for value:", selectedValue);
    }
  };

  // Handle root level changes
  const handleRootChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle personal details changes
  const handlePersonalChange = (section, field, value) => {
    setFormData((prev) => {
      // Personal Details
      if (section === "personalDetails") {
        return {
          ...prev,
          personalDetails: {
            ...prev.personalDetails,
            [field]: value,
          },
        };
      }

      // Security Details
      if (section === "securityDetails") {
        return {
          ...prev,
          securityDetails: {
            ...prev.securityDetails,
            [field]: value,
          },
        };
      }

      // Minor Details (top-level)
      if (section === "minorDetailsHolder") {
        return {
          ...prev,
          minorDetailsHolder: {
            ...prev.minorDetailsHolder,
            [field]: value,
          },
        };
      }

      // Minor Membership Holder Details (nested)
      if (section === "minorMembershipHolderDetails") {
        return {
          ...prev,
          minorDetailsHolder: {
            ...prev.minorDetailsHolder,
            minorMembershipHolderDetails: {
              ...prev.minorDetailsHolder.minorMembershipHolderDetails,
              [field]: value,
            },
          },
        };
      }

      return prev;
    });
  };

  // Handle debenture allotment changes
  const handleDebentureChange = (index, field, value, subField = null) => {
    setFormData((prev) => {
      const updated = [...prev.debentureAllotmentTransferDetails];

      if (subField) {
        if (
          field === "allotmentDistinctiveNumber" ||
          field === "transfereeDistinctiveNumber"
        ) {
          updated[index] = {
            ...updated[index],
            [field]: {
              ...updated[index][field],
              [subField]: value,
            },
          };
        } else if (field === "amount") {
          updated[index] = {
            ...updated[index],
            amount: {
              ...updated[index].amount,
              [subField]: value,
            },
          };
        }
      } else {
        updated[index] = {
          ...updated[index],
          [field]: value,
        };
      }

      return {
        ...prev,
        debentureAllotmentTransferDetails: updated,
      };
    });
  };

  // Add new debenture allotment
  const addDebentureAllotment = () => {
    setFormData((prev) => ({
      ...prev,
      debentureAllotmentTransferDetails: [
        ...prev.debentureAllotmentTransferDetails,
        createDebentureAllotmentTransferDetail(),
      ],
    }));
  };

    const addRange = (holdingIndex, field) => {
    setFormData((prev) => {
      const updated = [...prev.debentureAllotmentTransferDetails];

      if (!Array.isArray(updated[holdingIndex][field])) {
        updated[holdingIndex][field] = [];
      }

      // 🔥 AUTO-SUGGEST: Calculate suggested 'from' value based on last range
      const currentRanges = updated[holdingIndex][field];
      let suggestedFrom = "";

      if (currentRanges.length > 0) {
        const lastRange = currentRanges[currentRanges.length - 1];
        if (lastRange.to) {
          suggestedFrom = Number(lastRange.to) + 1;
        }
      }

      updated[holdingIndex][field] = [
        ...updated[holdingIndex][field],
        { from: suggestedFrom, to: "" },
      ];

      return { ...prev, debentureAllotmentTransferDetails: updated };
    });
  };

    const removeRange = (holdingIndex, field, rangeIndex) => {
    setFormData((prev) => {
      const updated = [...prev.debentureAllotmentTransferDetails];

      updated[holdingIndex][field] = updated[holdingIndex][field]
        .filter(Boolean)
        .filter((_, i) => i !== rangeIndex);

      return { ...prev, debentureAllotmentTransferDetails: updated };
    });
  };

  // Remove debenture allotment
  const removeDebentureAllotment = (index) => {
    if (formData.debentureAllotmentTransferDetails.length > 1) {
      setFormData((prev) => ({
        ...prev,
        debentureAllotmentTransferDetails:
          prev.debentureAllotmentTransferDetails.filter((_, i) => i !== index),
      }));
    }
  };

  // Handle form submission
  const handleSave = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Validation
    if (!formData.accountId) {
      const errorMsg = "Please select a company.";
      setError(errorMsg);
      console.error("❌ Validation failed: No company selected");
      alert(errorMsg);
      return;
    }

    if (!formData.classOfDebentures) {
      const errorMsg = "Please enter class of debentures.";
      setError(errorMsg);
      console.error("❌ Validation failed: No class of debentures");
      alert(errorMsg);
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      // Prepare the data according to the Postman payload structure
      const apiData = {
        classOfDebentures: formData.classOfDebentures,
        nominalValuePerUnit: Number(formData.nominalValuePerUnit) || 0,
        totalNumberOfDebentures: Number(formData.totalNumberOfDebentures) || 0,
        totalSharesHeld: Number(formData.totalSharesHeld) || 0,
        folioNumber: formData.folioNumber,

        personalDetails: {
          holderName: formData.personalDetails.holderName,
          jointHolderNames: formData.personalDetails.jointHolderNames || null,
          address: formData.personalDetails.address,
          emailId: formData.personalDetails.emailId,
          panNo: formData.personalDetails.panNo,
          uniqueIdentificationNo:
            formData.personalDetails.uniqueIdentificationNo || null,
          fatherOrMotherOrSpouseName:
            formData.personalDetails.fatherOrMotherOrSpouseName || null,
          occupation: formData.personalDetails.occupation || null,
          nationality: formData.personalDetails.nationality || "Indian",
        },

        securityDetails: {
          secured: formData.securityDetails.secured || null,
          chargeRegistrationDate:
            formData.securityDetails.chargeRegistrationDate,
          chargeIdentificationNumber:
            formData.securityDetails.chargeIdentificationNumber,
          assetParticulars: formData.securityDetails.assetParticulars,
        },

        minorDetailsHolder: {
          guardianName: formData.minorDetailsHolder.guardianName || null,
          minorDateOfBirth:
            formData.minorDetailsHolder.minorDateOfBirth || null,
          minorMembershipHolderDetails: {
            dateOfBecomingHolder:
              formData.minorDetailsHolder.minorMembershipHolderDetails
                .dateOfBecomingHolder || null,
            dateOfReceiptOfNomination:
              formData.minorDetailsHolder.minorMembershipHolderDetails
                .dateOfReceiptOfNomination || null,
            abeyanceSecuritiesCount:
              Number(
                formData.minorDetailsHolder.minorMembershipHolderDetails
                  .abeyanceSecuritiesCount,
              ) || 0,
            lienRecord:
              formData.minorDetailsHolder.minorMembershipHolderDetails
                .lienRecord || null,
            dateOfCessation:
              formData.minorDetailsHolder.minorMembershipHolderDetails
                .dateOfCessation || null,
          },
        },

        debentureAllotmentTransferDetails:
          formData.debentureAllotmentTransferDetails.map((item, index) => ({
            allotmentOrTransferNo:
              item.allotmentOrTransferNo ||
              `ALT-${String(index + 1).padStart(3, "0")}`,
            dateOfAllotmentOrTransfer: item.dateOfAllotmentOrTransfer || null,
            numberOfDebenturesOrSecuritiesAllottedOrTransferred:
              Number(
                item.numberOfDebenturesOrSecuritiesAllottedOrTransferred,
              ) || 0,
            allotmentDistinctiveNumber: {
              from: Number(item.allotmentDistinctiveNumber.from) || 0,
              to: Number(item.allotmentDistinctiveNumber.to) || 0,
            },
            folioOfTransferor: item.folioOfTransferor || null,
            nameOfTransferor: item.nameOfTransferor || null,
            dateOfIssueOrEndorsementOfCertificate:
              item.dateOfIssueOrEndorsementOfCertificate || null,
            certificateNumber: item.certificateNumber || null,
            amount: {
              amountPayable: Number(item.amount.amountPayable) || 0,
              amountPaid: Number(item.amount.amountPaid) || 0,
              amountDue: Number(item.amount.amountDue) || 0,
            },
            considerationOtherThanCashDetails:
              item.considerationOtherThanCashDetails || null,
            dateOfTransferTransmissionRedemptionForfeiture:
              item.dateOfTransferTransmissionRedemptionForfeiture || null,
            numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed:
              Number(
                item.numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed,
              ) || 0,
            transfereeDistinctiveNumber: {
              from: Number(item.transfereeDistinctiveNumber.from) || 0,
              to: Number(item.transfereeDistinctiveNumber.to) || 0,
            },
            folioOfTransferee: item.folioOfTransferee || null,
            nameOfTransferee: item.nameOfTransferee || null,
            balanceUnitsLeft: Number(item.balanceUnitsLeft) || 0,
            otherRemarks: item.otherRemarks || null,
            authentication: item.authentication || null,
          })),
      };

      console.log(
        "📤 Submitting MGT-2 data:",
        JSON.stringify(apiData, null, 2),
      );

      const response = await mgt2Api.submitMgt2Form(
        apiData,
        formData.accountId,
        token,
      );


      if (
        response &&
        (response.id || response._id || response.success || response.data)
      ) {
        alert("MGT-2 form submitted successfully!");
        console.log("🎉 Form submitted successfully!");

        // Reset form
        setFormData({
          accountId: "",
          companyName: "",
          classOfDebentures: "",
          nominalValuePerUnit: "",
          totalNumberOfDebentures: "",
          totalSharesHeld: "",
          folioNumber: "",
          personalDetails: createPersonalDetails(),
          securityDetails: createSecurityDetails(),
          minorDetailsHolder: createMinorDetailsHolder(),
          debentureAllotmentTransferDetails: [
            createDebentureAllotmentTransferDetail(),
          ],
        });
      } else {
        const errorMsg = "Failed to submit form. Please try again.";
        setError(errorMsg);
        console.error("❌ Unexpected response format:", response);
        alert(errorMsg);
      }
    } catch (err) {
      console.error("❌ ========== SUBMISSION ERROR ==========");
      console.error("❌ Error object:", err);
      console.error("❌ Error message:", err.message);
      console.error("❌ Error response:", err.response);
      console.error("❌ Error response data:", err.response?.data);

      const errorMsg = `Submission failed: ${err.response?.data?.message || err.message || "Please try again"}`;
      setError(errorMsg);
      alert(errorMsg);
    } finally {
      setSubmitting(false);
      console.log("🏁 Submission process completed");
    }
  };

  return (
    <div>
      {/* Header — matches MGT-1 */}
      <div className="bg-white border-b-4 px-6 py-2 mb-2 text-center shadow-sm rounded-xl relative">
        <button
          onClick={() => window.history.back()}
          className="absolute top-3 left-4 flex items-center gap-2 text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft size={18} />
          <span className="text-sm font-medium">Back</span>
        </button>
        <h1 className="text-2xl font-black uppercase tracking-tight">Form No. MGT - 2</h1>
        <h2 className="text-xl font-bold mt-1">Register of Debenture Holders / Other Securities Holders</h2>
        <p className="text-[10px] italic text-slate-500 mt-2 max-w-3xl mx-auto">
          [Pursuant to section 88 of the Companies Act, 2013 and rule 3(2) of the Companies
          (Management and Administration) Rules, 2014]
        </p>
      </div>

      {/* Company Selection */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-1">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Name of the company *
        </label>
        <select
          value={formData.accountId}
          onChange={handleCompanyChange}
          disabled={loading}
          className="w-50 px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select a company</option>
          {companies.map((company) => (
            <option key={company.id} value={company.id}>
              {company.accountName || `Company ${company.id}`}
            </option>
          ))}
        </select>
      </div>

      {/* Error Banner */}
      {error && (
        <div className="mb-2 px-4 py-1 rounded-lg text-sm font-medium border bg-red-50 text-red-800 border-red-200">
          {error}
        </div>
      )}

      {/* Main Details Card */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-md overflow-hidden mb-2">
        <div className="bg-primary text-white px-3 py-1">
          <span className="font-semibold text-sm uppercase tracking-widest text-white">
            MGT-2 Register Details
          </span>
        </div>

        <div className="p-3 space-y-2">
          {/* Basic Debenture Info */}
          <p className="text-xs text-slate-500 italic">
            (TO BE MAINTAINED SEPARATELY FOR EACH CLASS OF DEBENTURES / OTHER SECURITIES IN RESPECT OF EACH HOLDER)
          </p>
        </div>

        {/* Error Display */}
        {error && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-md">
            <p className="text-red-600 text-sm">{error}</p>
          </div>
        )}

        {/* Company Selection */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Name of the company *
          </label>
          <select
            value={formData.accountId}
            onChange={handleCompanyChange}
            disabled={loading}
            className="w-50 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select a company</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.accountName || `Company ${company.id}`}
              </option>
            ))}
          </select>
         
          {/* Loading/Status Messages */}
          {/* <div className="mt-2">
            {loading && (
              <p className="text-sm text-gray-500">Loading companies...</p>
            )}
            {!token && !loading && (
              <p className="text-sm text-red-600">
                Please login to view companies
              </p>
            )}
            {token && !loading && companies.length > 0 && (
              <p className="text-sm text-green-600">
                ✓ {companies.length} company(ies) loaded
              </p>
            )}
            {formData.companyName && (
              <p className="text-sm text-blue-600">
                Selected: {formData.companyName} (ID: {formData.accountId})
              </p>
            )}
          </div> */}
        </div>

         <p className="text-sm text-gray-600 ">
           (TO BE MAINTAINED SEPARATELY FOR EACH CLASS OF DEBENTURES / OTHER SECURITIES IN RESPECT OF EACH HOLDER)
          </p>

        {/* Basic Debenture Information */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
          <FormField
            label="Class of debentures"
            value={formData.classOfDebentures}
            onChange={(value) => handleRootChange("classOfDebentures", value)}
            required
          />
          <FormField
            label="Nominal value per unit (₹)"
            value={formData.nominalValuePerUnit}
            onChange={(value) => handleRootChange("nominalValuePerUnit", value)}
            type="number"
            required
          />
          <FormField
            label="Total number of debentures"
            value={formData.totalNumberOfDebentures}
            onChange={(value) =>
              handleRootChange("totalNumberOfDebentures", value)
            }
            type="number"
            required
          />
          <FormField
            label="Total shares held"
            value={formData.totalSharesHeld}
            onChange={(value) => handleRootChange("totalSharesHeld", value)}
            type="number"
            required
          />
        </div>
        <hr className="my-6 border-gray-800" />

        {/* Personal Details Section */}
        <div className="mb-2">
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Personal Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <FormField
              label="Holder name"
              value={formData.personalDetails.holderName}
              onChange={(value) =>
                handlePersonalChange("personalDetails", "holderName", value)
              }
              required
            />
            <FormField
              label="Joint holder names (if any)"
              value={formData.personalDetails.jointHolderNames}
              onChange={(value) =>
                handlePersonalChange(
                  "personalDetails",
                  "jointHolderNames",
                  value,
                )
              }
            />
            <FormField
              label="Address"
              value={formData.personalDetails.address}
              onChange={(value) =>
                handlePersonalChange("personalDetails", "address", value)
              }
              type="description"
              rows={2}
              required
            />
            <FormField
              label="Email ID"
              value={formData.personalDetails.emailId}
              onChange={(value) =>
                handlePersonalChange("personalDetails", "emailId", value)
              }
              type="email"
              required
            />
            <FormField
              label="PAN number"
              value={formData.personalDetails.panNo}
              onChange={(value) =>
                handlePersonalChange("personalDetails", "panNo", value)
              }
              required
            />
            <FormField
              label="Unique identification number"
              value={formData.personalDetails.uniqueIdentificationNo}
              onChange={(value) =>
                handlePersonalChange(
                  "personalDetails",
                  "uniqueIdentificationNo",
                  value,
                )
              }
            />
            <FormField
              label="Father/Mother/Spouse name"
              value={formData.personalDetails.fatherOrMotherOrSpouseName}
              onChange={(value) =>
                handlePersonalChange(
                  "personalDetails",
                  "fatherOrMotherOrSpouseName",
                  value,
                )
              }
            />
            <FormField
              label="Occupation"
              value={formData.personalDetails.occupation}
              onChange={(value) =>
                handlePersonalChange("personalDetails", "occupation", value)
              }
            />
            <FormField
              label="Nationality"
              value={formData.personalDetails.nationality}
              onChange={(value) =>
                handlePersonalChange("personalDetails", "nationality", value)
              }
            />
          </div>
        </div>

        <hr className="my-6 border-gray-800" />

        {/* Minor Details Section */}
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-800 mb-1">
            Minor Details (if applicable)
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <FormField
              label="Guardian name"
              value={formData.minorDetailsHolder.guardianName}
              onChange={(value) =>
                handlePersonalChange(
                  "minorDetailsHolder",
                  "guardianName",
                  value,
                )
              }
            />
            <FormField
              label="Minor date of birth"
              value={formData.minorDetailsHolder.minorDateOfBirth}
              onChange={(value) =>
                handlePersonalChange(
                  "minorDetailsHolder",
                  "minorDateOfBirth",
                  value,
                )
              }
              type="date"
            />
          </div>
          <div className="mt-3">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Minor Membership Holder Details
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <FormField
                label="Date of becoming holder"
                value={
                  formData.minorDetailsHolder.minorMembershipHolderDetails
                    .dateOfBecomingHolder
                }
                onChange={(value) =>
                  handlePersonalChange(
                    "minorMembershipHolderDetails",
                    "dateOfBecomingHolder",
                    value,
                  )
                }
                type="date"
              />
              <FormField
                label="Date of receipt of nomination"
                value={
                  formData.minorDetailsHolder.minorMembershipHolderDetails
                    .dateOfReceiptOfNomination
                }
                onChange={(value) =>
                  handlePersonalChange(
                    "minorMembershipHolderDetails",
                    "dateOfReceiptOfNomination",
                    value,
                  )
                }
                type="date"
              />
              <FormField
                label="Abeyance securities count"
                value={
                  formData.minorDetailsHolder.minorMembershipHolderDetails
                    .abeyanceSecuritiesCount
                }
                onChange={(value) =>
                  handlePersonalChange(
                    "minorMembershipHolderDetails",
                    "abeyanceSecuritiesCount",
                    value,
                  )
                }
                type="number"
              />
              <FormField
                label="Lien record"
                value={
                  formData.minorDetailsHolder.minorMembershipHolderDetails
                    .lienRecord
                }
                onChange={(value) =>
                  handlePersonalChange(
                    "minorMembershipHolderDetails",
                    "lienRecord",
                    value,
                  )
                }
              />
              <FormField
                label="Date of cessation"
                value={
                  formData.minorDetailsHolder.minorMembershipHolderDetails
                    .dateOfCessation
                }
                onChange={(value) =>
                  handlePersonalChange(
                    "minorMembershipHolderDetails",
                    "dateOfCessation",
                    value,
                  )
                }
                type="date"
              />
            </div>
          </div>
        </div>

        <hr className="my-6 border-gray-800" />

        {/* Security Details Section */}
        <div className="mb-2">
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Security Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <FormField
              label="Whether repayment of the debentures / other securities is secured: Yes/No"
              type="dropdown"
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
              value={formData.securityDetails.secured}
              onChange={(value) =>
                handlePersonalChange("securityDetails", "secured", value)
              }
            />

            <FormField
              label="Lock-in periodIf secured, date of registration of charge with the ROC"
              type="date"
              value={formData.securityDetails.chargeRegistrationDate}
              onChange={(value) =>
                handlePersonalChange(
                  "securityDetails",
                  "chargeRegistrationDate",
                  value,
                )
              }
            />
            <FormField
              label="Charge Identification Number allotted for the charge"
              value={formData.securityDetails.chargeIdentificationNumber}
              onChange={(value) =>
                handlePersonalChange(
                  "securityDetails",
                  "chargeIdentificationNumber",
                  value,
                )
              }
            />

            <FormField
              label="Brief particulars of the assets to secure such debentures / other securities"
              value={formData.securityDetails.assetParticulars}
              onChange={(value) =>
                handlePersonalChange(
                  "securityDetails",
                  "assetParticulars",
                  value,
                )
              }
            />
          </div>
        </div>

        <hr className="my-6 border-gray-800" />

        {/* Debenture Allotment/Transfer Details */}
        {formData.debentureAllotmentTransferDetails.map((detail, index) => (
          <div
            key={index}
            className="mb-5 p-3 bg-gray-100 border border-gray-400 rounded-lg"
          >
            <div className="bg-primary text-white px-3 py-2 flex justify-between items-center">
              <span className="font-semibold text-sm uppercase tracking-widest text-white">
                Debenture Allotment / Transfer Details #{index + 1}
              </span>
              {formData.debentureAllotmentTransferDetails.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeDebentureAllotment(index)}
                  className="text-[10px] text-red-600 flex flex-row items-center gap-2 font-bold uppercase transition bg-white p-1 rounded-md"
                >
                  <Trash2 size={16}/> <span>Allotment</span>
                </button>
              )}
            </div>

            <div className="p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
              <FormField
                label="Allotment or transfer number"
                value={detail.allotmentOrTransferNo}
                onChange={(value) =>
                  handleDebentureChange(index, "allotmentOrTransferNo", value)
                }
              />
              <FormField
                label="Date of allotment or transfer"
                value={detail.dateOfAllotmentOrTransfer}
                onChange={(value) =>
                  handleDebentureChange(
                    index,
                    "dateOfAllotmentOrTransfer",
                    value,
                  )
                }
                type="date"
              />
              <FormField
                label="Number of debentures/securities allotted or transferred"
                value={
                  detail.numberOfDebenturesOrSecuritiesAllottedOrTransferred
                }
                onChange={(value) =>
                  handleDebentureChange(
                    index,
                    "numberOfDebenturesOrSecuritiesAllottedOrTransferred",
                    value,
                  )
                }
                type="number"
              />

              {/* Distinctive Number Ranges */}
              <div className="col-span-full border rounded p-2 bg-gray-50">
                <div className="flex items-end justify-between mb-2">
                  <h4 className="text-sm font-bold uppercase mb-1 text-slate-700 underline">
                    Distinctive Number Ranges
                  </h4>
                  <button
                    onClick={() => addRange(index, "distinctiveNumberRanges")}
                    type="button"
                    className="bg-primary text-white text-sm gap-1 px-3 py-1.5 rounded flex flex-row items-center"
                  >
                    <Plus size={18} /> <span>Add Transfer Range</span>
                  </button>
                </div>
                {detail.distinctiveNumberRanges.map((range, rangeIndex) => (
                  <div key={rangeIndex} className="flex items-end gap-1 mb-1 p-2 bg-white border rounded">
                    <div className="flex-1 ">
                      <FormField
                        label={rangeIndex > 0 && detail.distinctiveNumberRanges[rangeIndex - 1]?.to
                          ? `From (min: ${Number(detail.distinctiveNumberRanges[rangeIndex - 1].to) + 1})`
                          : "From"}
                        type="number"
                        value={range.from}
                        onChange={(v) => handleDebentureChange(index, "distinctiveNumberRanges", v, "from", rangeIndex)}
                      />
                    </div>
                    <div className="flex-1">
                      <FormField
                        label="To"
                        type="number"
                        value={range.to}
                        onChange={(v) => handleDebentureChange(index, "distinctiveNumberRanges", v, "to", rangeIndex)}
                      />
                    </div>
                      <button
                        type="button"
                        onClick={() => removeRange(index, "distinctiveNumberRanges", rangeIndex)}
                        className="text-red-500"
                    >
                      <Trash2 size={18} />
                      </button>
                  </div>
                ))}
              </div>
              <FormField
                label="Folio of transferor"
                value={detail.folioOfTransferor}
                onChange={(value) =>
                  handleDebentureChange(index, "folioOfTransferor", value)
                }
              />
              <FormField
                label="Name of transferor"
                value={detail.nameOfTransferor}
                onChange={(value) =>
                  handleDebentureChange(index, "nameOfTransferor", value)
                }
              />
              <FormField
                label="Date of issue or endorsement of certificate"
                value={detail.dateOfIssueOrEndorsementOfCertificate}
                onChange={(value) =>
                  handleDebentureChange(
                    index,
                    "dateOfIssueOrEndorsementOfCertificate",
                    value,
                  )
                }
                type="date"
              />
              <FormField
                label="Certificate number"
                value={detail.certificateNumber}
                onChange={(value) =>
                  handleDebentureChange(index, "certificateNumber", value)
                }
              />
              <FormField
                label="Amount payable (₹)"
                value={detail.amount.amountPayable}
                onChange={(value) =>
                  handleDebentureChange(index, "amount", value, "amountPayable")
                }
                type="number"
              />
              <FormField
                label="Amount paid (₹)"
                value={detail.amount.amountPaid}
                onChange={(value) =>
                  handleDebentureChange(index, "amount", value, "amountPaid")
                }
                type="number"
              />
              <FormField
                label="Amount due (₹)"
                value={detail.amount.amountDue}
                onChange={(value) =>
                  handleDebentureChange(index, "amount", value, "amountDue")
                }
                type="number"
              />
              <FormField
                label="Consideration other than cash details"
                value={detail.considerationOtherThanCashDetails}
                onChange={(value) =>
                  handleDebentureChange(
                    index,
                    "considerationOtherThanCashDetails",
                    value,
                  )
                }
              />
              <FormField
                label="Date of transfer/transmission/redemption/forfeiture"
                value={detail.dateOfTransferTransmissionRedemptionForfeiture}
                onChange={(value) =>
                  handleDebentureChange(
                    index,
                    "dateOfTransferTransmissionRedemptionForfeiture",
                    value,
                  )
                }
                type="date"
              />
              <FormField
                label="Number of units transferred/transmitted/forfeited/redeemed"
                value={
                  detail.numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed
                }
                onChange={(value) =>
                  handleDebentureChange(
                    index,
                    "numberOfUnitsTransferredOrTransmittedOrForfeitedRedeemed",
                    value,
                  )
                }
                type="number"
              />

              {/* Transfer Distinctive Number Ranges */}
              <div className="col-span-full border rounded p-2 bg-gray-50">
                <div className="flex items-end justify-between mb-2">
                  <h4 className="text-sm font-bold uppercase mb-1 text-slate-700 underline">
                    Transfer Distinctive Number Ranges
                  </h4>
                  <button
                    onClick={() => addRange(index, "transferDistinctiveNumberRanges")}
                    type="button"
                    className="bg-primary text-white text-sm gap-1 px-3 py-1.5 rounded flex flex-row items-center"
                  >
                    <Plus size={18} /> <span>Add Transfer Range</span>
                  </button>
                </div>
                {detail.transferDistinctiveNumberRanges.map((range, rangeIndex) => (
                  <div key={rangeIndex} className="flex flex-wrap items-end gap-2 mb-1 p-2 bg-white border rounded">
                    <div className="flex-1">
                      <FormField
                        label={rangeIndex > 0 && detail.transferDistinctiveNumberRanges[rangeIndex - 1]?.to
                          ? `From (min: ${Number(detail.transferDistinctiveNumberRanges[rangeIndex - 1].to) + 1})`
                          : "From"}
                        type="number"
                        value={range.from}
                        onChange={(v) => handleDebentureChange(index, "transferDistinctiveNumberRanges", v, "from", rangeIndex)}
                      />
                    </div>
                    <div className="flex-1">
                      <FormField
                        label="To"
                        type="number"
                        value={range.to}
                        onChange={(v) => handleDebentureChange(index, "transferDistinctiveNumberRanges", v, "to", rangeIndex)}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={() => removeRange(index, "transferDistinctiveNumberRanges", rangeIndex)}
                      className="text-red-500"
                    >
                      <Trash2 size={18} />
                    </button>
                  </div>
                ))}
              </div>
              <FormField
                label="Folio of transferee"
                value={detail.folioOfTransferee}
                onChange={(value) =>
                  handleDebentureChange(index, "folioOfTransferee", value)
                }
              />
              <FormField
                label="Name of transferee"
                value={detail.nameOfTransferee}
                onChange={(value) =>
                  handleDebentureChange(index, "nameOfTransferee", value)
                }
              />
              <FormField
                label="Balance units left"
                value={detail.balanceUnitsLeft}
                onChange={(value) =>
                  handleDebentureChange(index, "balanceUnitsLeft", value)
                }
                type="number"
              />
              <FormField
                label="Other remarks"
                value={detail.otherRemarks}
                onChange={(value) =>
                  handleDebentureChange(index, "otherRemarks", value)
                }
                type="description"
                rows={2}
              />
              <FormField
                label="Authentication"
                value={detail.authentication}
                onChange={(value) =>
                  handleDebentureChange(index, "authentication", value)
                }
              />
            </div>
          </div>
        ))}

      {/* <div className="flex flex-row justify-between items-center mt-2 mb-4">
        <button
          type="button"
          onClick={addDebentureAllotment}
          className="bg-primary text-white text-[10px] px-4 py-2 rounded-md font-bold uppercase shadow-sm transition hover:bg-blue-700 mt-2 mr-2 mb-2"
        >
          + Add Debenture Allotment
        </button>
        <button
          type="button"
          onClick={handleSave}
          disabled={submitting || !formData.accountId}
          className="bg-primary text-white text-[10px] px-4 py-2 rounded-md font-bold uppercase shadow-sm transition hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed mt-2 ml-2 mb-2"
        >
          {submitting ? "Submitting..." : "Submit MGT-2 Form"}
        </button>
      </div> */}
      <div className="flex flex-row justify-between items-center mt-2 mb-4">
        <button
          type="button"
          onClick={addDebentureAllotment}
          className="bg-primary text-white px-3 py-1.5 rounded flex flex-row items-center"
        >
          <Plus /> <span>Add Debenture Allotment</span>
        </button>
        <button
          type="button"
          onClick={handleSave}
          disabled={submitting || !formData.accountId}
          className="bg-primary text-white px-3 py-1.5 rounded flex flex-row items-center"
        >
          {submitting ? "Submitting..." : "Submit MGT-2 Form"}
        </button>
      </div>
    </div>
    </div>
  );
};

export default MgtTwoForm;
